<div class="rs-modal-close">
  <button (click)="close()" class="rs-link-action rs-link-action-close">
    <span class="rs-action-link-icon" title="{{ 'common.overlayer.close.caption' | translate }}"
      ><span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span></span
    >
  </button>
</div>
<div class="rs-modal-heading">
  <span *ngIf="!isActiveOption()">
    {{ 'ebu.ordering.confirmation.modal.order' | translate }}
  </span>
  <span *ngIf="isActiveOption()">
    {{ 'ebu.ordering.confirmation.modal.cease' | translate }}
  </span>
  <h2 class="rs-modal-heading-title">
    <span *ngIf="canDoOrderAction">{{ getOptionName() }}</span>
  </h2>
</div>
<div class="rs-modal-content">
  <p>
    <mprd-price [option]="option" [showActiveStatus]="false" amountClass="rs-price-m"></mprd-price>
  </p>
  <div class="rs-form-item">
    <div class="rs-checkbox" style="padding-left: 2px">
      <input
        type="checkbox"
        id="checkbox-termsAndConditions-mypxsdialog"
        [checked]="acceptTermsAndConditions"
        (change)="acceptTermsAndConditions = !acceptTermsAndConditions"
        [required]="true"
      />
      <label for="checkbox-termsAndConditions-mypxsdialog">
        <span [innerHTML]="'ebu.ordering.confirmation.modal.priceDisclaimer' | translate"></span>
      </label>
    </div>
  </div>
</div>
<div class="rs-modal-footer">
  <div class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only">
    <div class="rs-flex-columns rs-order-m1">
      <p class="small-only-text-center">
        <a
          href="javacript:void(0)"
          (click)="cancel()"
          role="button"
          data-modal-close=""
          data-tms-button-name="cancel"
          data-tms-action-name="close"
        >
          {{ 'ebu.ordering.confirmation.cancel.button.label' | translate }}
        </a>
      </p>
    </div>
    <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
      <button
        class="rs-btn rs-btn-order"
        [disabled]="!acceptTermsAndConditions"
        [ngClass]="{ 'rs-btn-disabled': !acceptTermsAndConditions }"
        (click)="confirmOrder()"
      >
        <span>
          {{ 'ebu.ordering.confirmation.confirm.button.label' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
